import { Modal } from "react-bootstrap";
import { SplitPdfModalProps } from "./UploadDocument.types";
import { Button } from "../../components/button";

export const UploadOptionModal = ({
  show,
  showSyncWithDC,
  onDismissUpload,
  onSelectDontSplitFile,
  onSelectSplitFile,
  onSyncWithDigitalCalculator,
  isPdf,
}: SplitPdfModalProps) => {
  return (
    <Modal show={show} animation onHide={onDismissUpload}>
      <Modal.Header>
        <h5 className="modal-title" id="Dismiss Modal">
          Choose an upload method
        </h5>
        <div onClick={onDismissUpload}>
          <span className="font-20 cursor-pointer">&times;</span>
        </div>
      </Modal.Header>
      <Modal.Body className="flex-column gap-2">
        <Button className="btn btn-primary" onClick={onSelectDontSplitFile}>
          {isPdf
            ? "Upload file as single document"
            : "Continue with normal upload"}
        </Button>
        {isPdf && (
          <Button className="btn btn-secondary" onClick={onSelectSplitFile}>
            Split the file and upload it as multiple documents
          </Button>
        )}
        {showSyncWithDC && <Button
          className="btn btn-success"
          onClick={onSyncWithDigitalCalculator}
        >
          Sync with Digital Calculator
        </Button>}
        <Button className="btn btn-danger" onClick={onDismissUpload}>
          Cancel document upload
        </Button>
      </Modal.Body>
    </Modal>
  );
};
